// extracted by mini-css-extract-plugin
module.exports = {"figure":"FigureCaption_figure__3qOrg","half":"FigureCaption_half__2dwMx","caption":"FigureCaption_caption__1Lgtd","credits":"FigureCaption_credits__34yrx"};